'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Nft = require('../../nftModule/models/Nft.cjs');
var assert = require('../../../utils/assert.cjs');
var Operation = require('../../../types/Operation.cjs');
var Amount = require('../../../types/Amount.cjs');

// -----------------
// Operation
// -----------------

const Key = 'LoadBidOperation';

/**
 * Transforms a `LazyBid` model into a `Bid` model.
 *
 * ```ts
 * const bid = await metaplex
 *   .auctionHouse()
 *   .loadBid({ lazyBid };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const loadBidOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const loadBidOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      lazyBid,
      loadJsonMetadata = true
    } = operation.input;
    const bid = {
      ...lazyBid,
      model: 'bid',
      lazy: false
    };
    if (lazyBid.tokenAddress) {
      const asset = await metaplex.nfts().findByToken({
        token: lazyBid.tokenAddress,
        loadJsonMetadata
      }, scope);
      scope.throwIfCanceled();
      Nft.assertNftOrSftWithToken(asset);
      assert["default"](asset.metadataAddress.equals(lazyBid.metadataAddress), `Asset metadata address must be ${lazyBid.metadataAddress}`);
      return {
        ...bid,
        isPublic: false,
        asset,
        tokens: Amount.amount(lazyBid.tokens, asset.mint.currency)
      };
    }
    const asset = await metaplex.nfts().findByMetadata({
      metadata: lazyBid.metadataAddress,
      loadJsonMetadata
    }, scope);
    scope.throwIfCanceled();
    return {
      ...bid,
      isPublic: true,
      asset,
      tokens: Amount.amount(lazyBid.tokens, asset.mint.currency)
    };
  }
};

exports.loadBidOperation = loadBidOperation;
exports.loadBidOperationHandler = loadBidOperationHandler;
//# sourceMappingURL=loadBid.cjs.map
